import InputLabelStyled from "@/components/InputLabelStyled";
import TextFieldStyled from "@/components/TextFieldStyled";
import { calcAge } from "@/lib/helper";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { IconButton } from "@mui/material";
import Box from "@mui/material/Box";
import ButtonGroup from "@mui/material/ButtonGroup";
import Grid from "@mui/material/Grid";
import Slider from "@mui/material/Slider";
import { useEffect, useRef, useState } from "react";

function valuetext(value) {
  return `${value}`;
}

export const AverageAgeFilter = ({ onChange, min, max, disabled = false }) => {
  const [value, setValue] = useState([
    min > 100 ? calcAge(max) : min,
    max > 100 ? calcAge(min) : max,
  ]);
  let lastValues = [min, max];
  const pid = useRef(null);

  const handleSliderChanged = (event, newValue) => {
    if (
      newValue[0] === newValue[1] ||
      newValue[0] > newValue[1] ||
      newValue[1] < newValue[0]
    ) {
      return;
    }
    setValue(newValue);
  };

  const handleMinIncreased = (event) => {
    if (value[0] >= value[1] - 1) {
      setValue([value[0] + 1, value[1] + 1]);
      return;
    }
    setValue([value[0] + 1, value[1]]);
  };

  const handleMinDecreased = (event) => {
    if (value[0] <= min) {
      return;
    }
    setValue([value[0] - 1, value[1]]);
  };

  const handleMaxIncreased = (event) => {
    if (value[1] >= max) {
      return;
    }
    setValue([value[0], value[1] + 1]);
  };

  const handleMaxDecreased = (event) => {
    if (value[1] <= value[0] + 1) {
      setValue([value[0] - 1, value[1] - 1]);
      return;
    }
    setValue([value[0], value[1] - 1]);
  };

  useEffect(() => {
    console.debug("new age value", value);

    if (pid.current) {
      clearTimeout(pid.current);
    }

    pid.current = setTimeout(checkValueChanged, 125);
  }, [value]);

  const checkValueChanged = () => {
    if (value[0] === lastValues[0] && value[1] === lastValues[1]) {
      pid.current = null;
      if (onChange && typeof onChange === "function") {
        onChange(value);
      }
    } else {
      lastValues = [...value];
      pid.current = setTimeout(checkValueChanged, 125);
    }
  };

  const style = {
    "& .input": {
      "& label": {
        marginBottom: "0",
      },
      "& input": {
        padding: "0.75rem 1rem 0.71875rem 1rem !important",
      },
    },
  };

  return (
    <>
      <InputLabelStyled
        disabled={disabled}
        label="Durchschnittsalter der Musiker:innen"
      />
      <Grid container columnSpacing={3} sx={style}>
        <Grid item xs={12} textAlign="center">
          <Slider
            disabled={disabled}
            getAriaLabel={() => "Durchschnittsalter Musiker:innen"}
            value={value}
            onChange={handleSliderChanged}
            valueLabelDisplay="auto"
            min={min > 100 ? 0 : min}
            max={max > 100 ? 99 : max}
            getAriaValueText={valuetext}
            variant="AgeSlider"
          />
        </Grid>
        <Grid item xs={6} md={12} lg={6}>
          <ButtonGroup variant="contained">
            <IconButton
              variant="outlined-grey"
              aria-label="Minus"
              disabled={disabled || value[0] <= min}
              onClick={handleMinDecreased}
            >
              <RemoveIcon />
            </IconButton>
            <Box sx={style} className="input">
              <TextFieldStyled
                name="age_min"
                placeholder="0"
                value={value[0]}
                min={min}
                max={max - 1}
                numeric={true}
                readonly={disabled}
              />
            </Box>
            <IconButton
              variant="outlined-grey"
              aria-label="Plus"
              disabled={disabled || value[0] >= max - 1}
              onClick={handleMinIncreased}
            >
              <AddIcon />
            </IconButton>
          </ButtonGroup>
        </Grid>
        <Grid item xs={6} md={12} lg={6}>
          <ButtonGroup variant="contained">
            <IconButton
              variant="outlined-grey"
              aria-label="Minus"
              disabled={disabled || value[1] <= min + 1}
              onClick={handleMaxDecreased}
            >
              <RemoveIcon />
            </IconButton>
            <Box sx={style} className="input">
              <TextFieldStyled
                name="age_max"
                placeholder="99"
                min={min + 1}
                max={max}
                value={value[1]}
                numeric={true}
                readonly={disabled}
              />
            </Box>
            <IconButton
              variant="outlined-grey"
              aria-label="Plus"
              disabled={disabled || value[1] >= max}
              onClick={handleMaxIncreased}
            >
              <AddIcon />
            </IconButton>
          </ButtonGroup>
        </Grid>
      </Grid>
    </>
  );
};
